import OrmModel from '~/models/abstracts/base/OrmModel'

export default class Administration extends OrmModel {
  //
}
